import { render, staticRenderFns } from "./vm18-skokka.vue?vue&type=template&id=3f5a3459&"
import script from "./vm18-skokka.vue?vue&type=script&lang=js&"
export * from "./vm18-skokka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5a3459')) {
      api.createRecord('3f5a3459', component.options)
    } else {
      api.reload('3f5a3459', component.options)
    }
    module.hot.accept("./vm18-skokka.vue?vue&type=template&id=3f5a3459&", function () {
      api.rerender('3f5a3459', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/svg/vm18-skokka.vue"
export default component.exports